import React from 'react';
import { Search } from './components/Search';
import { CreateBtn } from './components/CreateBtn';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import { IsActiveCheckbox } from './components/IsActiveCheckbox';
import { ResetBtn } from './components/ResetBtn';
import { SortBy } from './components/SortBy/SortBy';
import { CountOfItem } from './components/CountOfItem';
import { WithURLFilters } from './components/WithURLFilters';
import style from './WatchControlPanel.module.scss';

export const WatchControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.selectWrapper}>
					<CustomerSelect />
					<RestaurantSelect />
					<IsActiveCheckbox />
				</div>
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};
